// component
import PaymentListItem from "../../components/kits/paymentListItem/PaymentListItem";
import { ArrowRightIcon } from "../../components/kits/Icons/Icons";
import useAxios from "../../services/useAxios";
import AuthenticationContext from "../../context/Authentication/AuthenticationContext";
// style
import "./paymentList.scss";
// react imports
import { useState, useEffect, useContext } from "react";
import { NavLink } from "react-router-dom";

export default function PaymentList({}) {
  const auth = useContext(AuthenticationContext);
  const [paymantListItemProp, setPaymantListItemProp] = useState([]);
  const { execute: getPaymentList } = useAxios("api/payment_list", {
    id: auth.userInfo.id,
  });
  useEffect(() => {
    async function loadPage() {
      getPaymentList().then((res) => {
        setPaymantListItemProp(res.payment_list.reverse());
      });
    }
    loadPage();
  }, []);

  return (
    <>
      <div className="parentPaymantList pd-20 d-flex flex-column">
        <div className="d-flex mr-t-10 ">
          <NavLink to={"/user-profile"}>
            <div>
              <ArrowRightIcon></ArrowRightIcon>
            </div>
          </NavLink>

          <div className="mr-r-4 title-paymentList title-h3-b ">
            {" "}
            لیست پرداخت ها
          </div>
        </div>
        {paymantListItemProp.length > 0 && (
          <div className="discription mr-t-16 desc-l">
            در پرداخت های ناموفق بانکی اگر مبلغ از حسابتان کسر شود؛ در کمتر از
            یک ساعت ونهایتا تا ۴۸ ساعت به شما برگردانده خواهدشد.
          </div>
        )}

        <>
          {paymantListItemProp.length > 0 ? (
            <>
              {" "}
              {paymantListItemProp.map((val, ind) => {
                return (
                  <>
                    <div className="mr-t-24">
                      <PaymentListItem
                        // title={` از${val.from[0].title}`}
                        title={
                          `از ${val.supplier_title}`
                          // val.type == "2" ? val.from.fullname : val.from.title
                        }
                        payType={"online"}
                        payResult={val.main_status == 4 ? "success" : "failed"}
                        price={val.amount}
                        timestamp={val.mtm}
                        currency={"تومان"}
                      ></PaymentListItem>
                    </div>

                    <div className="SeparatingLine mr-t-16"></div>
                  </>
                );
              })}
            </>
          ) : (
            <div className="text-center d-flex flex-column align-items-center justify-content-center flex-grow-1">
              {/* <div className="box "></div> */}
              <div className="message mr-t-12 desc-c-l">
                هنوز مبلغی پرداخت نشده است.
              </div>
            </div>
          )}
        </>
      </div>
    </>
  );
}
